var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.125C11.52 7.85737 12.7443 8.25089 14 8.25V5.75C13.0717 5.75 12.1815 5.38125 11.5251 4.72487C10.8687 4.0685 10.5 3.17826 10.5 2.25H8V10.25C7.99998 10.5632 7.91592 10.8706 7.75659 11.1402C7.59726 11.4098 7.3685 11.6317 7.09418 11.7828C6.81985 11.9339 6.51001 12.0086 6.19699 11.9991C5.88396 11.9896 5.57921 11.8963 5.31454 11.7289C5.04987 11.5615 4.83496 11.3261 4.69226 11.0473C4.54955 10.7686 4.48426 10.4566 4.50321 10.144C4.52215 9.83142 4.62463 9.52964 4.79996 9.27015C4.97529 9.01065 5.21705 8.80297 5.5 8.66875V6.06875C4.70411 6.21144 3.96544 6.57821 3.3707 7.12601C2.77596 7.6738 2.34983 8.37989 2.14233 9.16139C1.93483 9.94289 1.95457 10.7674 2.19923 11.538C2.4439 12.3087 2.90333 12.9936 3.52361 13.5123C4.14388 14.031 4.89926 14.362 5.70106 14.4665C6.50287 14.5709 7.31783 14.4444 8.05028 14.1019C8.78273 13.7594 9.40228 13.2151 9.83619 12.5328C10.2701 11.8505 10.5004 11.0586 10.5 10.25V7.125Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/TiktokIcon.fb5f85a5b560b17a63050df78c29f9f2.svg";
export { ForwardRef as ReactComponent };